export type CycleCountFrequency = 'Weekly' | 'Monthly';

/** The cycle-count session lifecycle states the API produces (see CycleCountUtils.ValidStatuses). */
export type CycleCountStatus = 'Draft' | 'InProgress' | 'Complete' | 'Adjusted';

export interface CycleCountConfig {
  warehouseId: number;
  warehouseName: string;
  locationId: number;
  frequency: CycleCountFrequency;
  countSize: number;
  isEnabled: boolean;
  lastRunDate: string | null;
  nextScheduledDate: string | null;
  cycleCountId: string | null;
  cycleCountStatus: CycleCountStatus | null;
  reportRecipients: string | null;
  /**
   * #35726: the warehouse's most recent Complete/Adjusted count. Optional because an older API
   * build omits it; absent or null means "no completed count".
   */
  lastCompletedCycleCountId?: string | null;
}

export interface GenerateCycleCountRequest {
  warehouseId: number;
  locationId: number;
}

export interface GenerateCycleCountResponse {
  cycleCountId: string;
  warehouseId: number;
  warehouseName: string;
  itemCount: number;
  createdDate: string;
}
